export default __webpack_public_path__ + "static/media/stories-image-4.826060bb.png";